import React, { useEffect, useState } from 'react'
import useMyProfile from '../../../../hooks/useMyProfile'
import { deleteBlog, getBlogById } from '../../../../../redux/api/blogs.api'
import LoadingComp from '../../../../components/LoadingComp'

import './styles.scss'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { DEFAULT_PROFILE_IMAGE } from '../../../../constants/otherConstsnts'
import moment from 'moment'
import { Button, Divider, notification, Popconfirm, Tag } from 'antd'
import { PhotoProvider } from 'react-photo-view'
import ReactQuill from 'react-quill'
import { Card, Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { handleDeleteBlob, USER_POSTS } from '../../../../azure/blob'

const Blog = () => {
    const url = window.location.pathname
    const blogId = url.split('/').pop()
    const [blog, setBlog] = useState(null)
    const [loading, setLoading] = useState(false)
    const myProfile = useMyProfile().userProfile;
    const [api, contextHolder] = notification.useNotification();
    const navigate = useNavigate()

    useEffect(() => {
        handleGetBlog()
    }, [])

    const handleGetBlog = async () => {
        setLoading(true)
        try {
            const response = await getBlogById(blogId)
            setBlog(response.data)
        } catch (error) {
            console.log('ERROR GETTING BLOG', error)
        }
        setLoading(false)
    }

    const getBlobName = (blobUrl) => {
        const splitUrl = blobUrl.split('/')
        return splitUrl[splitUrl.length - 1]
    }

    const handleDeleteBlog = async () => {
        let images = blog.blogImages ? blog.blogImages.split(',') : [];

        if (images.length > 0) {
            const imageDeletePromises = images.map(async (image, index) => {
                const blobName = getBlobName(image);
                return handleDeleteBlob(USER_POSTS, blobName);
            });
            await Promise.all(imageDeletePromises);
        }

        const response = await deleteBlog(blog?.id);
        if (response.status === 200) {
            api.success({
                message: 'Blog Deleted',
                description: 'You have successfully deleted the blog',
            });
            setTimeout(() => {
                navigate('/dashboard/my-blogs');
            }, 1500);
        } else {
            api.error({
                message: 'Error',
                description: 'An error occured while deleting the blog',
            });
        }
    }

    return (
        <div className='blog_container'>
            {contextHolder}
            {
                loading ?
                    <div className='loading_container'>
                        <LoadingComp />
                    </div>
                    :
                    <div className='blog'>
                        <div className='blog_header'>
                            <div className='blog_meta'>
                                <h1 className='header_1'>{blog?.blogTitle}</h1>
                                <div className='author'>
                                    <div className='author_image'>
                                        <LazyLoadImage
                                            alt='author'
                                            src={blog?.profilePicUrl || DEFAULT_PROFILE_IMAGE}
                                            effect='blur'
                                        />
                                    </div>
                                    <div className='author_name'>
                                        <h3>{blog?.userName}</h3>
                                        <p>{moment(blog?.createdAt, 'MMM D YYYY h:mma').format('MMMM Do YYYY')}</p>
                                    </div>
                                </div>
                            </div>
                            {myProfile?.id === blog?.userId &&
                                <div className='actions'>
                                    <Button
                                        type='primary'
                                        onClick={() => navigate(`/dashboard/my-blogs/edit/${blog?.id}`)}
                                    >
                                        <EditOutlined />
                                        Edit
                                    </Button>
                                    <Popconfirm
                                        title='Are you sure you want to delete this blog?'
                                        onConfirm={handleDeleteBlog}
                                        okText='Yes'
                                        cancelText='No'
                                    >
                                        <Button
                                            type='primary'
                                            danger
                                        >
                                            <DeleteOutlined />
                                            Delete
                                        </Button>
                                    </Popconfirm>
                                </div>
                            }
                        </div>

                        <div className='blog_short'>
                            <p className='short_description'>{blog?.blogDescription}</p>
                            <div className='tags'>
                                {
                                    blog?.blogTags?.split(',')?.map(tag => (
                                        <Tag key={tag} color='cyan'>#{tag}</Tag>
                                    ))
                                }
                            </div>
                        </div>

                        {blog?.tagedDestinations && <div className='tagged_destinations' style={{ marginBottom: '10px' }}>
                            <h2 className='header_4'>Tagged Destinations</h2>
                            <div className='tags' style={{ marginTop: '10px' }}>
                                {
                                    blog?.tagedDestinations?.map(tag => (
                                        <Tag
                                            key={tag}
                                            color='geekblue'
                                            onClick={() => window.location.href = `/destinations/${tag?.id}`}
                                        >
                                            {tag?.destinationName}
                                        </Tag>
                                    ))
                                }
                            </div>
                        </div>}

                        {blog?.tagedAttractions && <div>
                            <h2 className='header_4'>Tagged Attractions</h2>
                            <div className='tags' style={{ marginTop: '10px' }}>
                                {
                                    blog?.tagedAttractions?.map(tag => (
                                        <Tag key={tag} color='geekblue'>{tag?.attractionName}</Tag>
                                    ))
                                }
                            </div>
                        </div>}

                        <Divider />

                        <div className='blog_content'>
                            <ReactQuill
                                value={blog?.blogContent}
                                readOnly={true}
                                theme='bubble'
                            />
                        </div>

                        {blog?.blogImages &&
                            <PhotoProvider>
                                <div className='blog_images'>
                                    {
                                        blog?.blogImages?.split(',')?.map(image => (
                                            <LazyLoadImage
                                                alt='blog_image'
                                                src={image}
                                                effect='blur'
                                            />
                                        ))
                                    }
                                </div>
                            </PhotoProvider>
                        }
                        {blog?.taggedTourPackages &&
                            <div>
                                <Divider />
                                <h1 className='heder_2' style={{ marginBottom: '10px' }}>
                                    Related Tour Packages
                                </h1>
                                <Row xs={1} md={2} lg={3} xl={3} className="g-4">
                                    {blog?.taggedTourPackages?.map((item, idx) => (
                                        <Col key={idx}>
                                            <Card
                                                data-aos="fade-up"
                                                data-aos-delay={`${idx * 100}`}
                                                className='package__card'
                                                style={{
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                }}
                                                onClick={() => navigate(`/tours/${item?.id}`)}

                                            >
                                                <LazyLoadImage
                                                    src={item?.thumbnailUrl}
                                                    alt={item?.packageName}
                                                    effect='blur'
                                                />

                                                <Card.Body
                                                    className='destination__card__content'
                                                >
                                                    <h2>{item?.packageName}</h2>
                                                    <div className='tags'>
                                                        {
                                                            item?.tags?.split(',').map((tag, idx) => (
                                                                <Tag > {tag} </Tag>
                                                            ))
                                                        }
                                                    </div>
                                                    <ReactQuill
                                                        value={item?.shotDescription}
                                                        readOnly={true}
                                                        theme='bubble'
                                                    />
                                                    <div className='package__card__footer'>
                                                        <div className='left'>
                                                            <span className='rating'>4.7/5</span>
                                                            {
                                                                item?.discountAmount > 0 && (
                                                                    <span className='discount'>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" viewBox="0 0 18 23" fill="none">
                                                                            <path d="M14.5246 9.70643C14.2888 10.087 14.0065 10.4602 13.6799 10.8261C13.5214 11.0041 13.3291 11.1487 13.1141 11.2516C12.8991 11.3545 12.6657 11.4135 12.4277 11.4252C12.1894 11.4389 11.9509 11.4052 11.7258 11.326C11.5007 11.2467 11.2936 11.1235 11.1165 10.9636C10.9122 10.78 10.7521 10.5525 10.6483 10.2982C10.5446 10.0439 10.4998 9.76938 10.5174 9.49527C10.5911 8.33143 10.2129 6.9638 9.39285 5.42674C8.9779 4.65576 8.48192 3.99773 7.89018 3.45264C7.82959 3.8422 7.73005 4.22469 7.59308 4.59438C7.25694 5.49425 6.77407 6.33223 6.16406 7.07429C5.74054 7.59375 5.25764 8.06182 4.72522 8.46893C3.8904 9.10978 3.2029 9.94215 2.74129 10.8727C2.26897 11.818 2.02428 12.8607 2.02678 13.9174C2.02678 15.7564 2.75111 17.485 4.06473 18.7888C5.38326 20.095 7.13393 20.812 9 20.812C10.8661 20.812 12.6167 20.095 13.9353 18.7888C15.2489 17.4875 15.9732 15.7564 15.9732 13.9174C15.9732 12.9549 15.7743 12.0194 15.3839 11.1404C15.1556 10.6247 14.8683 10.1459 14.5246 9.70643Z" fill="#FBFBFB" />
                                                                            <path d="M16.9087 10.4576C16.432 9.38473 15.7391 8.42179 14.8732 7.62901L14.1587 6.97343C14.1345 6.95178 14.1053 6.93642 14.0737 6.92869C14.0421 6.92096 14.0091 6.9211 13.9776 6.9291C13.9461 6.9371 13.917 6.95271 13.8929 6.97457C13.8688 6.99643 13.8505 7.02386 13.8395 7.05446L13.5203 7.9703C13.3214 8.54486 12.9556 9.13169 12.4375 9.7087C12.4031 9.74553 12.3638 9.75535 12.3368 9.7578C12.3098 9.76026 12.2681 9.75535 12.2313 9.72097C12.1969 9.69151 12.1797 9.64731 12.1821 9.60312C12.273 8.12499 11.831 6.4578 10.8636 4.6433C10.0632 3.13571 8.9509 1.95959 7.56117 1.1395L6.5471 0.542849C6.41451 0.464278 6.24509 0.567402 6.25246 0.72209L6.30648 1.90066C6.34331 2.70602 6.25001 3.41807 6.02902 4.00981C5.75893 4.73414 5.37099 5.40691 4.875 6.01093C4.52984 6.43071 4.13862 6.81039 3.70871 7.14285C2.6733 7.93879 1.83138 8.95867 1.24599 10.1261C0.662039 11.3037 0.35786 12.6003 0.357147 13.9147C0.357147 15.0737 0.585495 16.1958 1.03728 17.254C1.47352 18.2729 2.10305 19.1976 2.89108 19.977C3.68661 20.7627 4.60983 21.3815 5.63862 21.8112C6.70425 22.258 7.83371 22.4839 9.00001 22.4839C10.1663 22.4839 11.2958 22.258 12.3614 21.8136C13.3877 21.3864 14.3209 20.7635 15.1089 19.9795C15.9045 19.1937 16.5281 18.2754 16.9627 17.2565C17.4138 16.2011 17.6453 15.0649 17.6429 13.9172C17.6429 12.719 17.3973 11.5551 16.9087 10.4576ZM13.9353 18.7886C12.6167 20.0949 10.8661 20.8118 9.00001 20.8118C7.13393 20.8118 5.38326 20.0949 4.06474 18.7886C2.75112 17.4848 2.02679 15.7562 2.02679 13.9172C2.02679 12.8491 2.26742 11.8252 2.7413 10.8725C3.20291 9.94196 3.89041 9.10959 4.72523 8.46874C5.25764 8.06163 5.74055 7.59356 6.16407 7.0741C6.77791 6.32522 7.25916 5.49039 7.59309 4.59419C7.73006 4.2245 7.82959 3.84201 7.89018 3.45245C8.48193 3.99754 8.97791 4.65557 9.39286 5.42655C10.213 6.96361 10.5911 8.33124 10.5174 9.49508C10.4998 9.76919 10.5446 10.0437 10.6484 10.298C10.7521 10.5524 10.9122 10.7798 11.1165 10.9634C11.2936 11.1233 11.5007 11.2465 11.7258 11.3258C11.9509 11.405 12.1895 11.4387 12.4277 11.425C12.9114 11.4004 13.3558 11.1868 13.6799 10.8259C14.0065 10.46 14.2888 10.0868 14.5246 9.70624C14.8683 10.1458 15.1556 10.6245 15.3839 11.1402C15.7743 12.0192 15.9732 12.9547 15.9732 13.9172C15.9732 15.7562 15.2489 17.4873 13.9353 18.7886Z" fill="#272727" />
                                                                        </svg>
                                                                        <h3>
                                                                            Hot Deal
                                                                        </h3>
                                                                    </span>
                                                                )
                                                            }
                                                        </div>
                                                        <div className='price'>
                                                            <span className='price__from'>from </span>
                                                            <span className='amount'>{item?.startingPrice}</span> AUD
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        }
                    </div>
            }
        </div>
    )
}

export default Blog